var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7679_16588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0898 0.976562C9.73711 0.976562 9.41719 1.18984 9.28047 1.51797C9.14375 1.84609 9.22031 2.2207 9.46914 2.47227L10.6012 3.60156L5.97187 8.23359C5.63008 8.57539 5.63008 9.13047 5.97187 9.47227C6.31367 9.81406 6.86875 9.81406 7.21055 9.47227L11.8398 4.84023L12.9719 5.97227C13.2234 6.22383 13.598 6.29766 13.9262 6.16094C14.2543 6.02422 14.4676 5.70703 14.4676 5.35156V1.85156C14.4676 1.36758 14.0766 0.976563 13.5926 0.976563L10.0898 0.976562ZM2.65234 1.85156C1.44375 1.85156 0.464844 2.83047 0.464844 4.03906V12.7891C0.464844 13.9977 1.44375 14.9766 2.65234 14.9766H11.4023C12.6109 14.9766 13.5898 13.9977 13.5898 12.7891V9.72656C13.5898 9.24258 13.1988 8.85156 12.7148 8.85156C12.2309 8.85156 11.8398 9.24258 11.8398 9.72656V12.7891C11.8398 13.0297 11.643 13.2266 11.4023 13.2266H2.65234C2.41172 13.2266 2.21484 13.0297 2.21484 12.7891V4.03906C2.21484 3.79844 2.41172 3.60156 2.65234 3.60156H5.71484C6.19883 3.60156 6.58984 3.21055 6.58984 2.72656C6.58984 2.24258 6.19883 1.85156 5.71484 1.85156H2.65234Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7679_16588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.464844 0.976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.e00b3333389e7bb20b978ca2fa80b395.svg";
export { ForwardRef as ReactComponent };